import { z } from 'zod'
import { UuidSchema } from '../../../utils/zodUuid'
import { StringSchema } from '../../../utils/zodStrings'

const NormalizedLongTextValueSchema = z.preprocess(
  (value) => (typeof value === 'string' && value.trim() === '' ? null : value),
  StringSchema.max(4000).nullable()
) satisfies z.ZodType<string | null, unknown>

/**
 * Creates a long-text schema that normalizes whitespace before applying the
 * intrinsic length limit and configured required rule.
 */
export function createLongTextValueSchema(required: boolean) {
  return NormalizedLongTextValueSchema.default(null).refine(
    (value) => !required || value !== null,
    { message: 'Required' }
  )
}

/**
 * Creates a selection-value schema. Database-backed reference
 * checks remain a server responsibility.
 */
export function createSelectionValueSchema(required: boolean, single: boolean) {
  return z
    .array(UuidSchema)
    .default([])
    .superRefine((value, context) => {
      if (required && value.length === 0)
        context.addIssue({
          code: 'custom',
          message: 'Required',
        })

      if (new Set(value).size !== value.length)
        context.addIssue({
          code: 'custom',
          message: 'Selected options must not contain duplicate IDs',
        })

      if (single && value.length > 1)
        context.addIssue({
          code: 'custom',
          message: 'Only one option may be selected',
        })
    }) satisfies z.ZodType<string[], unknown>
}
